import { ClubSearchSelect } from '~/pages/club/components/club-search-select';
import { schema, Schema } from './team-form.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';
import { DivisionSearchSelect } from '~/pages/divisions/components/division-select';

interface Props {
  onSubmit: (data: Schema) => void;
  mode: 'create' | 'edit';
  defaultValues?: Schema;
  isLoading: boolean;
}

export function TeamForm({ defaultValues, mode, isLoading, onSubmit }: Props) {
  const { formState, register, handleSubmit, watch, setValue, trigger } = useForm({
    defaultValues: defaultValues ?? {},
    resolver: zodResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="name" label="Namn">
            <Input.Field type="text" {...register('name')} />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group label="Förening" htmlFor="club" formState={formState}>
            <ClubSearchSelect
              placeholder="Sök på förening..."
              onChange={v => {
                setValue('club', v as [string, number]);
                trigger('club');
              }}
              formState={formState}
              value={watch('club')}
            />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12, md: 6 }}>
          <Input.Group formState={formState} htmlFor="division" label="Division">
            <DivisionSearchSelect
              placeholder="Sök på division..."
              onChange={v => {
                setValue('division', v as [string, number]);
                trigger('division');
              }}
              formState={formState}
              value={watch('division')}
            />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Button.Group align="right">
        <Button type="submit" isLoading={isLoading}>
          {{ create: 'Skapa', edit: 'Spara' }[mode]}
        </Button>
      </Button.Group>
    </form>
  );
}
